const formEl = document.querySelector('#subscribe-form');

function formFeedback(text) {
  const el = $('.newsletter--box__callout.description');
  el.html(`<p>${text}</p>`);
}

function getSuccessText() {
  const msg = $('.newsletter--box__callout.description').data('success');
  return msg;
}

function handleSubscribe() {
  console.log('handleSubscribe', formEl);
  if (!formEl) return;
  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    const $recaptcha = $(this).find('.g-recaptcha');
    if ($recaptcha.length && window.not_robot === false) {
      return;
    }
    const { action } = this.dataset;
    if (!action) return;
    const form = this;
    try {
      $.ajax({
        method: 'POST',
        url: action,
        data: $(this).serialize(),
      }).done((response) => {
        if (response.status === 'success') {
          const msg = getSuccessText();
          formFeedback(msg || 'Success!');
          form.reset();
        } else {
          formFeedback('Sorry we could not subscribe you at this time.');
        }
      });
    } catch (error) {
      console.error(error);
    }
  });
}
handleSubscribe();
